import axios from 'axios'
import router from './router'

// Response interceptor
axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response || {}
    
    if (status === 401) {
      // Token expired or invalid - redirect to login
      localStorage.removeItem('authUser')
      router.push('/login')
    }
    
    return Promise.reject(error)
  }
)

export default axios
